import React from 'react';
import { Flex, Input } from '@upsales/components';
import { get } from 'lodash';
import type {
	WidgetDataSourceProps,
	EditWidgetRowProps,
	WidgetRow
} from 'App/components/hooks/integrations/externalIntegrationTypes';
import UiWidgetRow, { EditUiWidgetRow } from './UiWidgetRow';
import WidgetFieldSetting from './helpers/WidgetFieldSetting';
import { removeBracketsFromTag } from './UiWidgetHelpers';
import { useTranslation } from 'Components/Helpers/translate';

// Edit version
export const EditUiWidgetConditional = ({ row, onUpdate, dataSources }: EditWidgetRowProps) => {
	const { t } = useTranslation();
	const handleUpdateConditional = (key: string, value: any) => {
		const updated = { ...row, settings: { ...row.settings, [key]: value } };
		onUpdate(updated);
	};

	const handleUpdateRow = (updatedRow: WidgetRow) => {
		onUpdate(updatedRow);
	};

	return (
		<Flex direction="column" gap="u2">
			<Flex direction="column" gap="u1">
				<Flex gap="u1" alignItems="center">
					<WidgetFieldSetting text={t('default.tag')}>
						<Input
							value={row.settings?.tag || ''}
							onChange={e => handleUpdateConditional('tag', e.target.value)}
						/>
					</WidgetFieldSetting>
					<WidgetFieldSetting text={t('default.value')}>
						<Input
							value={row.settings?.value || ''}
							onChange={e => handleUpdateConditional('value', e.target.value)}
						/>
					</WidgetFieldSetting>
				</Flex>
				<EditUiWidgetRow
					row={row}
					onUpdate={updatedRow => handleUpdateRow(updatedRow)}
					dataSources={dataSources}
				/>
			</Flex>
		</Flex>
	);
};

// View version
const UiWidgetConditional: React.FC<WidgetDataSourceProps> = ({
	row,
	dataSources,
	widgetExternalId,
	widgetSettings,
	widgetType
}) => {
	const tag = row.settings?.tag;
	const value = row.settings?.value;
	let translatedTag = tag ?? '';
	if (translatedTag.includes('{{index}}') && row.settings?.index !== undefined) {
		translatedTag = translatedTag.replace('{{index}}', row.settings?.index);
	}
	translatedTag = removeBracketsFromTag(translatedTag);
	const valueFromDataSource = `${get(dataSources, translatedTag, '')}`;

	const match = tag && valueFromDataSource === value;
	if (!match) {
		return null;
	}

	return (
		<UiWidgetRow
			row={row}
			widgetExternalId={widgetExternalId}
			dataSources={dataSources}
			widgetSettings={widgetSettings}
			widgetType={widgetType}
		/>
	);
};

export default UiWidgetConditional;
